import clsx from "clsx";
import shape from "../../assets/img/shapes/hero-shape-01.webp";


const HeroShape01 = ( props:any ) => {

    return (
        <div className={clsx("rmdr-hero-shape-01", props.className)}>
            <img src={shape} alt="rmdr-hero-shape-01" loading="lazy" width={750} height={574} />
        </div>
    )

}

export default HeroShape01;
